import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "debit-payment-confirmation content position-relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "item-secondary-title pt-2" }, "You have not accepted the cover.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "item-content" }, " Your adviser has been informed and will be in contact to discuss your application. ", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}